import { useCurrentUser } from '../use-current-user/hook';
import { calculateRouteOptions } from './common';

export const usePossibleRoutes = () => {
	const { currentUser } = useCurrentUser();
	return calculateRouteOptions(currentUser?.roles ?? []);
};
